// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.notification-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 8px 40px rgb(7 7 7 / 8%);
    padding: 10px;
    margin-top: 10px;
}

@media (min-width:810px) {
    .notification-container{
        flex-direction: row;
        justify-content: space-between;
    }
    .message{
        width: 75%;
    }
}


.template-card-notification{
    box-shadow: 0 8px 40px rgb(7 7 7 / 8%);
    padding: 10px;
    width: 90% ;
}`, "",{"version":3,"sources":["webpack://./src/components/notifications/index.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sCAAsC;IACtC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;AACJ;;;AAGA;IACI,sCAAsC;IACtC,aAAa;IACb,WAAW;AACf","sourcesContent":["\n.notification-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-shadow: 0 8px 40px rgb(7 7 7 / 8%);\n    padding: 10px;\n    margin-top: 10px;\n}\n\n@media (min-width:810px) {\n    .notification-container{\n        flex-direction: row;\n        justify-content: space-between;\n    }\n    .message{\n        width: 75%;\n    }\n}\n\n\n.template-card-notification{\n    box-shadow: 0 8px 40px rgb(7 7 7 / 8%);\n    padding: 10px;\n    width: 90% ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
